import React, { ChangeEvent } from 'react';
import { Add } from '@material-ui/icons';
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { useStyles } from "../styles"
import { useTranslation } from 'react-i18next';
interface ITimingCheckboxProps {
  onChange: (keyName: string, enabled: boolean) => void;
  keyName: string;
  addTime: (keyName: string, index?: number, status?: boolean) => void;
  enabled: boolean;
}

export function TimingCheckbox({ onChange, keyName, addTime, enabled }: ITimingCheckboxProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  function handleChangeEventCheckbox(ev: ChangeEvent<HTMLInputElement>) {
    const name = ev.target.name;
    const value = ev.target.checked;
    onChange(name, value);
  }
  return (
    <div className={classes.TimingCheckboxWrapper}>
      <FormControlLabel
        control={<Checkbox
          checked={Boolean(enabled)}
          onChange={handleChangeEventCheckbox}
          data-component-name={`TIMING_CHECKBOX_${keyName}`}
          className={enabled ? "CHECKED" : "UNCHECKED"}
          color="primary"
          name={keyName} />}
        label={t(`days.${keyName?.toLowerCase()}`)}
      />

      {enabled && <Add onClick={() => addTime(keyName, undefined, true)} />}
    </div>
  )
}
